import React, { useEffect, useState } from 'react';
import Podium from './Podium';
import { Player } from '../classes/Player';
import { Dialogs } from '../constants/Dialogs';
import HeaderInGame from '../HeaderInGame';

interface WinnerInterface {
    dialog: Dialogs;
    setDialog: any;
    players: Player[];
    setPlayers: any;
    scoresMap: Map<number, number>;
    setScoresMap: any;
    shouldGoHome: boolean;
    setShouldGoHome: any;
};

function WinnerDialog({dialog, setDialog, players, setPlayers, scoresMap, setScoresMap, shouldGoHome, setShouldGoHome}: WinnerInterface) {
    const crown = require("../images/crown.png");

    const [playersMap, setPlayersMap] = useState<Map<number, number[]>>(new Map<number, number[]>());
    const [highestScore, setHighestScore] = useState(-1);
    const [secondHighestScore, setSecondHighestScore] = useState(-1);
    const [thirdHighestScore, setThirdHighestScore] = useState(-1);

    const determineHighestScores = () => {
        const tempPlayersMap: Map<number, number[]> = new Map<number, number[]>();
        let tempHighestScore = 0;
        let tempSecondHighestScore = 0;
        let tempThirdHighestScore = 0;

        for (let idx = 0; idx < players.length; idx++) {
            const playerId = players[idx].id;
            let score = 0;
            if (scoresMap.get(playerId) !== undefined) {
                score = scoresMap.get(playerId)!;
            }

            if (tempPlayersMap.get(score) === undefined) {
                tempPlayersMap.set(score, [playerId]);
            } else {
                tempPlayersMap.get(score)!.push(playerId);
            }
        }

        tempPlayersMap.forEach((v, k) => {
            const score = k;
            if (score > tempHighestScore) {
                tempThirdHighestScore = tempSecondHighestScore;
                tempSecondHighestScore = tempHighestScore;
                tempHighestScore = score;
            } else if (score > tempSecondHighestScore) {
                tempThirdHighestScore = tempSecondHighestScore;
                tempSecondHighestScore = score;
            } else if (score > tempThirdHighestScore) {
                tempThirdHighestScore = score;
            }
        });

        if (tempSecondHighestScore === tempThirdHighestScore) {
            tempThirdHighestScore = -1;
        }

        setPlayersMap(tempPlayersMap);
        setHighestScore(tempHighestScore);
        setSecondHighestScore(tempSecondHighestScore);
        setThirdHighestScore(tempThirdHighestScore)
    }

    const goHome = () => {
        setShouldGoHome(true)
        setDialog(Dialogs.survey);
    }

    const goToKeyMomentsPage = () => {
        setShouldGoHome(false);
        setDialog(Dialogs.survey);
    }

    const getWinnerName = () => {
        const firstPlace = playersMap.get(highestScore) ?? [];
        for (let idx = 0; idx < firstPlace.length; idx++) {
            const playerIdx = players.findIndex((p) => p.id === firstPlace[idx]);
            if (playerIdx !== -1) {
                return players[playerIdx].name;
            }
        }
        return "";
    }

    const getWinnerAvatar = () => {
        const firstPlace = playersMap.get(highestScore) ?? [];
        for (let idx = 0; idx < firstPlace.length; idx++) {
            const playerIdx = players.findIndex((p) => p.id === firstPlace[idx]);
            if (playerIdx !== -1) {
                return players[playerIdx].image;
            }
        }
        return "";
    }

    useEffect(() => {
        determineHighestScores();
    }, [])

    return (
        <div className="overallWrapper">
            <HeaderInGame/>
            <div className="winnerWrapper">
                <div className="winnerName">
                    {getWinnerName() + " wins!"}
                </div>
                <div className="winnerContentWrapper">
                    <img className="winnerCrown" src={crown} alt="crown"/>
                    {getWinnerAvatar() && <img className="winnerImage" src={require("../images/avatars/" + getWinnerAvatar() + ".png")} alt="winner avatar"/>}
                    <div className="winnerPodiumWrapper">
                        <Podium players={players} playersMap={playersMap} score={secondHighestScore} place={2}/>
                        <Podium players={players} playersMap={playersMap} score={highestScore} place={1}/>
                        <Podium players={players} playersMap={playersMap} score={thirdHighestScore} place={3}/>
                    </div>
                    <button className="winnerHomeButton" onClick={goHome}>HOME</button>
                    <div className="winnerViewKeyMoments" tabIndex={0} onClick={goToKeyMomentsPage} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        goToKeyMomentsPage();
                    }
                }}>View Key Moments</div>
                    <div>Screenshot & share with your friends</div>
                </div>
            </div>
        </div>
    );
};

export default WinnerDialog;